import React from 'react'
import classnames from 'classnames'

interface Meta {
  error: string
  submitFailed: boolean
}

export interface Props {
  label: string
  iconClassNames: string
  input: object
  meta: Meta
}

const InputGroupField = ({ label, iconClassNames, input, meta, ...rest }) => {
  const { submitFailed, error } = meta

  return (
    <div className="form__group">
      <label className="form__label" htmlFor={input.name}>
        {label}
      </label>
      <div className="input-group">
        <i className={`input-group__icon ${iconClassNames}`} />
        <input
          id={input.name}
          {...input}
          {...rest}
          className={classnames('form__control', {
            'form__control--error': submitFailed && error,
          })}
        />
        {submitFailed && error && (
          <p className="form__help-text text-error">{error}</p>
        )}
      </div>
    </div>
  )
}

export default InputGroupField
